export default "__VITE_ASSET__9d2dfde1__"